import React from "react";
import { useOutletContext } from "react-router-dom";
import LegalHtmlPage from "../components/LegalHtmlPage";

export default function EulaPage() {
  const { isRtl, text } = useOutletContext();
  const title = isRtl ? text.Arabic14 : "EULA";
  return <LegalHtmlPage title={title} htmlField="eula" />;
}
